import Nav from "./Nav";
import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchPurchaseReport, deletePurchase } from "./api";

const Purchasereport = () => {
  const queryClient = useQueryClient();

  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(today);
  const [date1, setDate1] = useState(today);

  // Fetch purchase report
  const { data = [{}, 0], isLoading } = useQuery({
    queryKey: ["purchaseReport", date, date1],
    queryFn: () => fetchPurchaseReport({ date, date1 }),
    keepPreviousData: true,
  });

  const reportData = data[0] || {};
  const total = data[1] || 0;
  const value = Object.keys(reportData);

  // Delete mutation
  const deleteMutation = useMutation({
    mutationFn: deletePurchase,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["purchaseReport", date, date1],
      }),
  });

  const handleDelete = (id) => {
    deleteMutation.mutate(id);
  };

  const handleFetch = () => {
    queryClient.invalidateQueries({
      queryKey: ["purchaseReport", date, date1],
    });
  };

  return (
    <>
      <Nav />
      <div
        className="report-container"
        style={{
          margin: "5% auto",
          padding: 20,
          maxWidth: "100%",
          background: "#f9f9f9",
          borderRadius: 12,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <div className="row g-3 mb-3">
          <div className="col-md-5">
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-md-5">
            <input
              type="date"
              value={date1}
              onChange={(e) => setDate1(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-md-2">
            <button onClick={handleFetch} className="btn btn-primary w-100">
              Fetch
            </button>
          </div>
        </div>

        <div
          className="total-display"
          style={{
            fontSize: "1.2em",
            fontWeight: "bold",
            color: "#00796b",
            marginTop: 15,
          }}
        >
          Total: ₹{total}
        </div>

        {isLoading ? (
          <p>Loading...</p>
        ) : (
          value.map((e) => {
            let index = 1;
            let groupTotal = 0;

            return (
              <div
                key={e}
                className="table-section"
                style={{
                  marginTop: 30,
                  padding: 15,
                  background: "white",
                  borderRadius: 12,
                  boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
                }}
              >
                <h5 className="mb-3" style={{ color: "#1e88e5" }}>
                  {e}
                </h5>
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr style={{ background: "#42a5f5", color: "white" }}>
                        <th>Sl No</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData[e].map((d) => {
                        groupTotal += d[2];
                        return (
                          <tr key={d[0]}>
                            <td>{index++}</td>
                            <td>{d[1]}</td>
                            <td>₹{d[2]}</td>
                            <td>{d[3]}</td>
                            <td>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(d[0])}
                                disabled={deleteMutation.isLoading}
                              >
                                {deleteMutation.isLoading
                                  ? "Deleting..."
                                  : "Delete"}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      <tr style={{ fontWeight: "bold" }}>
                        <td colSpan={5}>Group Total = ₹{groupTotal}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default Purchasereport;
